export enum ActionLinkType {
    HREF,
    ROUTERLINK,
    GOBACK,
}
